// extracted by mini-css-extract-plugin
export var active = "_71-a";
export var activeIndicator = "_71-8";
export var animate = "_71-9";
export var disabled = "_71-b";
export var fullWidth = "_71-2";
export var lg = "_71-7";
export var md = "_71-6";
export var redoButtonTabGroup = "_71-0";
export var sm = "_71-5";
export var tabButton = "_71-3";
export var tabButtonsContainer = "_71-1";
export var xs = "_71-4";